function HeartIcon(props) {
  return (
    <svg {...props}>
      <path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
    </svg>
  );
}

function LightbulbIcon(props) {
  return (
    <svg {...props}>
      <path d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
    </svg>
  );
}

function SparkleIcon(props) {
  return (
    <svg {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
    </svg>
  );
}

export const SHARE_INTRO_OPTIONS = [
  {
    id: "casual",
    title: "Casual",
    quote: "I saw this card and thought it was interesting.",
    icon: SparkleIcon,
  },
  {
    id: "thoughtful",
    title: "Thoughtful",
    quote: "I saw this card and thought of us.",
    icon: LightbulbIcon,
  },
  {
    id: "personal",
    title: "Personal",
    quote: "I made this card thinking of us.",
    icon: HeartIcon,
  },
];

export const DEFAULT_SHARE_INTRO_ID = "thoughtful";

export function getShareIntroOptionById(optionId) {
  return (
    SHARE_INTRO_OPTIONS.find((option) => option.id === optionId) ||
    SHARE_INTRO_OPTIONS.find((option) => option.id === DEFAULT_SHARE_INTRO_ID) ||
    SHARE_INTRO_OPTIONS[0]
  );
}

export function getShareIntroQuoteById(optionId) {
  return getShareIntroOptionById(optionId)?.quote || "";
}
